$(function(){
    // Set selected client id
    $('#selected_client_id').val($('#client_id').val());
    $( "#client_id" ).change(function() {
        $('#selected_client_id').val($('#client_id').val());
    });

    // Confirmation modal after deleting items
    $('#deleteModal').on("show.bs.modal", function (e) {
        $("#deleteModalLabel").html($(e.relatedTarget).data('title'));
        $("#fav-title").html($(e.relatedTarget).data('title'));
        $("#id").val($(e.relatedTarget).data('id'));
        $('#deleteForm').attr('action', $(e.relatedTarget).data('url'));
    });

    $('#deactivateModal').on("show.bs.modal", function (e) {
        $("#deactivateModalLabel").html($(e.relatedTarget).data('title'));
        $("#deactivateTitle").html($(e.relatedTarget).data('title'));
        $("#id").val($(e.relatedTarget).data('id'));
        $('#deactivateForm').attr('action', $(e.relatedTarget).data('url'));
    });

    $('#deleteEmployeeFromWorkorderModal').on("show.bs.modal", function (e) {
        $("#deleteModalLabel").html($(e.relatedTarget).data('title'));
        $("#fav-title").html($(e.relatedTarget).data('title'));
        $("#id").val($(e.relatedTarget).data('id'));
        $("#workorder_id").val($(e.relatedTarget).data('workorder-id'));
        $("#modal_employee_id").val($(e.relatedTarget).data('employee-id'));

        $('#deleteForm').attr('action', $(e.relatedTarget).data('url'));
    });

    $('#activateModal').on("show.bs.modal", function (e) {
        $("#activateModalLabel").html($(e.relatedTarget).data('title'));
        $("#activateTitle").html($(e.relatedTarget).data('title'));
        $("#id").val($(e.relatedTarget).data('id'));
        $('#activateForm').attr('action', $(e.relatedTarget).data('url'));
    });

    $('#updateEmployeeOnWorkorderModal').on("show.bs.modal", function (e) {
        $("#id").val($(e.relatedTarget).data('id'));
        $("#updateEmployeeOnWorkorderWorkorder_id").val($(e.relatedTarget).data('workorder-id'));
        $("#updateEmployeeOnWorkorderTitleModalHeader").html($(e.relatedTarget).data('title'));
        $("#current_employee_id").val($(e.relatedTarget).data('employee-id'));
        $("#current_jobfunction_id").val($(e.relatedTarget).data('jobfunction-id'));
        $('#employee_id').val($(e.relatedTarget).data('employee-id'));
        $('#jobfunction_id').val($(e.relatedTarget).data('jobfunction-id'));
    });

    $('#addEmployeeToWorkorderModal').on("show.bs.modal", function (e) {
        $("#addEmployeeToWorkorderWorkorder_id").val($(e.relatedTarget).data('id'));
        $("#addEmployeeOnWorkorderTitleModalHeader").html($(e.relatedTarget).data('title'));
    });

    $('#sendToExactModal').on("show.bs.modal", function (e) {
        $("#sendToExactId").val($(e.relatedTarget).data('id'));
        $('#sendToExactForm').attr('action', $(e.relatedTarget).data('url'));
    });
});



// WEBPACK FOOTER //
// ./resources/js/components/modals.js